import React from 'react';

const PIPELINE_TABS = [
  // Founder spec May 24, 2026: animatics is its own first-class tab —
  // animatics artists were unable to find their tasks because the
  // pipeline strip went straight from CBA to ASSET BUILD without
  // showing them where their work lived.
  { key: 'storyboard',  label: 'STORYBOARD', color: '#a78bfa' },
  { key: 'animatics',   label: 'ANIMATICS', color: '#c084fc' },
  // PIPELINE REFORM R4 — CBA is a first-class tab
  { key: 'cba', label: 'CBA', color: '#8b5cf6' },
  // PIPELINE REFORM R3 — Modeling + Texturing merged into ASSET BUILD
  { key: 'asset_build', label: 'ASSET BUILD', color: '#06b6d4' },
  { key: 'rigging', label: 'RIGGING', color: '#f59e0b' },
  { key: 'layout', label: 'LAYOUT', color: '#10b981' },
  { key: 'animation', label: 'ANIMATION', color: '#3b82f6' },
  { key: 'lighting', label: 'LIGHTING', color: '#8b5cf6' },
  { key: 'compositing', label: 'COMPING', color: '#ec4899' },
];

export { PIPELINE_TABS };

export default function PipelineTabs({ tasks = [], activeTab, onTabChange, showAll = false }) {
  // Group tasks by type — count legacy modeling+texturing under asset_build
  const grouped = {};
  PIPELINE_TABS.forEach(t => { grouped[t.key] = { total: 0, completed: 0, in_progress: 0 }; });
  tasks.forEach(t => {
    let tt = t.task_type || 'other';
    // Roll legacy task types into the merged tab so old projects show counts.
    if (tt === 'modeling' || tt === 'texturing') tt = 'asset_build';
    if (!grouped[tt]) grouped[tt] = { total: 0, completed: 0, in_progress: 0 };
    grouped[tt].total++;
    if (t.status === 'completed') grouped[tt].completed++;
    if (t.status === 'in_progress') grouped[tt].in_progress++;
  });

  const allTabs = showAll
    ? [...PIPELINE_TABS, ...Object.keys(grouped).filter(k => !PIPELINE_TABS.find(p => p.key === k)).map(k => ({ key: k, label: k.toUpperCase().replace(/_/g, ' '), color: '#71717a' }))]
    : PIPELINE_TABS;

  return (
    <div className="flex gap-1 border-b border-zinc-800 overflow-x-auto" data-testid="pipeline-tabs">
      {showAll && (
        <button onClick={() => onTabChange('all')}
          className={`px-4 py-2.5 text-xs font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${activeTab === 'all' ? 'border-white text-white' : 'border-transparent text-zinc-500 hover:text-zinc-300'}`}>
          ALL <span className="text-[9px] font-mono ml-1 px-1.5 py-0.5 rounded bg-zinc-800 text-zinc-400">{tasks.length}</span>
        </button>
      )}
      {allTabs.map(tab => {
        const data = grouped[tab.key] || { total: 0, completed: 0 };
        return (
          <button key={tab.key} onClick={() => onTabChange(tab.key)}
            className={`px-4 py-2.5 text-xs font-medium border-b-2 -mb-px flex items-center gap-2 whitespace-nowrap transition-colors ${activeTab === tab.key ? 'text-white' : 'text-zinc-500 hover:text-zinc-300'}`}
            style={{ borderBottomColor: activeTab === tab.key ? tab.color : 'transparent' }}>
            {tab.label}
            {data.total > 0 && (
              <span className="text-[9px] font-mono px-1.5 py-0.5 rounded" style={{ backgroundColor: `${tab.color}20`, color: tab.color }}>
                {data.completed}/{data.total}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
